import { SET_MODAL_SAMPLE_VIDEO } from 'store/types/sample-video';

export const setModalSampleVideo = (modal) => {
  return {
    type: SET_MODAL_SAMPLE_VIDEO,
    payload: modal,
  };
};
